import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthRouter from './routers/AuthRouter';
import AuthProvider from './context/auth/AuthProvider'
import PrivateAdminRouter from './routers/PrivateAdminRouter';
import AdminRouter from './routers/AdminRouter';
import PrivateOperatorRouter from './routers/PrivateOperatorRouter';
import OperatorRouter from './routers/OperatorRouter';
import PrivateManagerRouter from './routers/PrivateManagerRouter';
import ManagerRouter from './routers/ManagerRouter';
import PrivateAdministrativeRouter from './routers/PrivateAdministrativeRouter';
import AdministrativeRouter from './routers/AdministrativeRouter';

export default function App() {

  return (
    <>
      
      <BrowserRouter>
        <AuthProvider>    
          <Routes>
              <Route path="/admin/*" element={ <PrivateAdminRouter><AdminRouter /></PrivateAdminRouter>} />
              <Route path="/operator/*" element={ <PrivateOperatorRouter><OperatorRouter /></PrivateOperatorRouter>} />
              <Route path="/manager/*" element={ <PrivateManagerRouter><ManagerRouter /></PrivateManagerRouter>} />
              <Route path="/administrative/*" element={ <PrivateAdministrativeRouter><AdministrativeRouter /></PrivateAdministrativeRouter>} />
              <Route path="*" element={<AuthRouter />}/>
          </Routes>
        </AuthProvider>    
      </BrowserRouter>   

    </>
  )
}
